import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';

const API_URL = import.meta.env.VITE_API_URL || '';

interface Province {
    id: string;
    name: string;
    slug: string;
    enabled: boolean;
    municipalities?: { count: number }[];
}

export default function Provinces() {
    const { token } = useAuthStore();
    const queryClient = useQueryClient();
    const [showForm, setShowForm] = useState(false);
    const [name, setName] = useState('');
    const [slug, setSlug] = useState('');

    const { data: provinces, isLoading } = useQuery<Province[]>({
        queryKey: ['provinces'],
        queryFn: async () => {
            const res = await fetch(`${API_URL}/admin/provinces`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.json();
        }
    });

    const createMutation = useMutation({
        mutationFn: async () => {
            const res = await fetch(`${API_URL}/admin/provinces`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ name, slug })
            });
            return res.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['provinces'] });
            setShowForm(false);
            setName('');
            setSlug('');
        }
    });

    return (
        <div>
            <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2>🗺️ Provincias</h2>
                <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
                    + Nueva Provincia
                </button>
            </div>

            {showForm && (
                <div className="card" style={{ marginBottom: '1rem' }}>
                    <h3>Crear Provincia</h3>
                    <div className="form-group">
                        <label className="form-label">Nombre</label>
                        <input
                            className="form-input"
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                setSlug(e.target.value.toLowerCase().replace(/\s+/g, '-'));
                            }}
                            placeholder="San Juan"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Slug (URL)</label>
                        <input className="form-input" value={slug} onChange={(e) => setSlug(e.target.value)} />
                    </div>
                    <button className="btn btn-primary" onClick={() => createMutation.mutate()}>
                        Crear
                    </button>
                </div>
            )}

            <div className="card">
                {isLoading ? (
                    <p>Cargando...</p>
                ) : (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Slug</th>
                                <th>Municipios</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {provinces?.map((p) => (
                                <tr key={p.id}>
                                    <td>{p.name}</td>
                                    <td><code>{p.slug}</code></td>
                                    <td>{p.municipalities?.[0]?.count || 0}</td>
                                    <td>
                                        <span className={`badge ${p.enabled ? 'badge-success' : 'badge-warning'}`}>
                                            {p.enabled ? 'Activo' : 'Inactivo'}
                                        </span>
                                    </td>
                                    <td>
                                        <Link to={`/provinces/${p.id}/municipalities`} className="btn" style={{ padding: '0.5rem' }}>
                                            Ver Municipios →
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
